<h2 class="mat-dialog-title">{{ "Reminder" | translate }}</h2>
<mat-dialog-content>
  <div>
    <!-- <form class="form-width">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ response }}</mat-label>
        <textarea matInput rows="6" cols="100" disabled></textarea>
      </mat-form-field>
    </form> -->
    {{ response }}
  </div>
</mat-dialog-content>
<mat-dialog-content>
  <h3>{{ "Do you want to send reminder?" | translate }}</h3>
</mat-dialog-content>
<!-- 
<div mat-dialog-actions class="mat-card-action">
  <button mat-raised-button mat-dialog-close>Close</button>
</div> -->

<mat-dialog-actions align="end">
  <div class="buttons">
    <button mat-flat-button mat-dialog-close>Close</button>
    <button mat-raised-button class="ms-2" color="primary" (click)="onClick()">
      {{ "Send" | translate }}
    </button>
  </div>
</mat-dialog-actions>
